export default __webpack_public_path__ + "static/media/password-bg.d72ebc96.png";